<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <busqueda-miembro ref="busquedaRef" @seleccionado="onMiembroSeleccionado" />

    <v-card class="mx-auto mt-3 px-5 rounded-xl elevation-2" v-if="!miembro" max-width="800">
      <v-card-title class="justify-center text-center">
        <v-icon color="#4318FF" size="48" class="mb-2">mdi-qrcode-scan</v-icon>
        <div class="text-h5 font-weight-black w-full" style="color: #1B2559;">
          CONTROL DE ACCESO LIVE FIT
        </div>
      </v-card-title>
      <v-card-text class="text-center subtitle-1">
        Escanee el carnet o busque al socio manualmente.
      </v-card-text>
      <v-card-actions class="justify-center py-6">
        <v-btn x-large color="#4318FF" dark class="rounded-xl px-8" @click="mostrarDialogoRegular = true">
          <v-icon left>mdi-account-cash</v-icon>
          Visita regular (Pase diario)
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mx-auto mt-3 rounded-xl elevation-4 overflow-hidden" max-width="450" v-if="miembro">
      <v-img :src="urlImagen(miembro.imagen)" height="250px" class="align-end">
        <div style="background: rgba(0,0,0,0.6); padding: 15px;">
          <h2 class="white--text text-h5 font-weight-bold">{{ miembro.nombre }}</h2>
          <span class="white--text">Matrícula: {{ miembro.matricula }}</span>
        </div>
      </v-img>

      <v-card-text class="pa-6">
        <div class="d-flex justify-space-between align-center mb-4">
          <span class="text-h6 font-weight-bold">Estado:</span>
          <v-chip class="font-weight-black" :color="estado(miembro.estado)" text-color="white" large>
            {{ miembro.estado || 'SIN MEMBRESÍA' }}
          </v-chip>
        </div>

        <v-alert v-if="miembro.membresia" :color="miembro.estado === 'ACTIVO' ? 'success' : 'error'" outlined border="left">
          {{ miembro.membresia }} - Vence: {{ miembro.fechaFin }}
        </v-alert>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn v-if="miembro.estado === 'ACTIVO'" block x-large color="#4318FF" dark class="rounded-xl" 
               @click="registrar" :loading="cargando">
          <v-icon left>mdi-check-circle</v-icon> CONFIRMAR ENTRADA
        </v-btn>

        <v-btn v-else block x-large color="warning" dark class="rounded-xl" @click="abrirRealizarPago">
          <v-icon left>mdi-credit-card-plus</v-icon> RENOVAR MEMBRESÍA
        </v-btn>
      </v-card-actions>
      
      <v-btn block text color="grey" @click="cancelarSeleccion" class="mb-2">Cancelar / Volver</v-btn>
    </v-card>

    <v-dialog v-model="mostrarRealizarPago" persistent max-width="600">
      <realizar-pago :matricula="matricula" @cerrar="cerrarDialogoPago" @pagado="onPagado" />
    </v-dialog>

    <v-dialog v-model="mostrarDialogoRegular" persistent max-width="500px">
      <v-card class="rounded-xl pa-4">
        <v-card-title class="text-h5 font-weight-bold">Cobro Pase Diario</v-card-title>
        <v-card-text>
          <v-text-field label="Monto" v-model="pagoVisita" outlined prefix="S/" type="number" class="mt-4" autofocus></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="mostrarDialogoRegular = false">Cancelar</v-btn>
          <v-btn color="#4318FF" dark class="rounded-lg px-6" :loading="cargando" @click="registrarVisitaRegular">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top rounded="pill">
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import BusquedaMiembro from "../Miembros/BusquedaMiembro.vue";
import RealizarPago from "../Miembros/RealizarPago.vue";
import Utiles from "../../Servicios/Utiles";
import HttpService from "../../Servicios/HttpService";

export default {
  name: "RegistrarVisita",
  components: { BusquedaMiembro, RealizarPago },

  data: () => ({
    miembro: null,
    mostrarRealizarPago: false,
    mostrarDialogoRegular: false,
    cargando: false,
    mensaje: {},
    mostrarMensaje: false,
    matricula: "",
    pagoVisita: "10.00"
  }),

  mounted() {
    this.enfocarBuscador();
  },

  methods: {
    enfocarBuscador() {
      this.$nextTick(function() {
        if (this.$refs.busquedaRef && this.$refs.busquedaRef.$el) {
          var input = this.$refs.busquedaRef.$el.querySelector('input');
          if (input) input.focus();
        }
      }.bind(this));
    },

    onMiembroSeleccionado(miembro) {
      if (!miembro) return; 
      this.miembro = miembro;
      this.matricula = miembro.matricula;
  
    },

    cancelarSeleccion() {
      this.miembro = null;
      this.enfocarBuscador();
    },

    registrar() {
      if (!this.miembro || this.cargando) return;
      this.cargando = true;
      var payload = {
        metodo: "registrar",
        visita: {
          idMiembro: this.miembro.id,
          idMembresia: this.miembro.idMembresia,
          idUsuario: localStorage.getItem("idUsuario"),
        },
      };

      HttpService.registrar(payload, "visitas.php").then(function(resultado) {
        if (resultado) {
          this.notificar("¡Entrada registrada correctamente!", "success");
          this.miembro = null;
          this.cargando = false;
          this.enfocarBuscador();
        }
      }.bind(this));
    },

    registrarVisitaRegular() {
      if (!this.pagoVisita) return;
      this.cargando = true;
      HttpService.registrar({
        metodo: 'registrar_regular',
        visita: { idUsuario: localStorage.getItem('idUsuario'), pago: this.pagoVisita }
      }, 'visitas.php')
      .then(function(resultado) {
        if (resultado) {
          this.cargando = false;
          this.mostrarDialogoRegular = false;
          this.notificar("Visita regular cobrada y registrada", "success");
          this.pagoVisita = "10.00";
          this.enfocarBuscador();
        }
      }.bind(this));
    },

    onPagado(resultado) {
      if (resultado) {
        this.mostrarRealizarPago = false;
        this.notificar("Pago exitoso. Vuelva a escanear para entrar.", "success");
        this.miembro = null;
        this.enfocarBuscador();
      }
    },

    abrirRealizarPago() {
      this.matricula = this.miembro.matricula;
      this.mostrarRealizarPago = true;
    },
    cerrarDialogoPago() { this.mostrarRealizarPago = false; },
    urlImagen(imagen) { return Utiles.generarURL(imagen); },
    estado(val) {
      return val === "ACTIVO" ? "#05cd99" : val === "VENCIDO" ? "#EE5D50" : "#FFB547";
    },
    notificar(texto, color) {
      this.mensaje = { texto: texto, color: color };
      this.mostrarMensaje = true;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Visitas/RegistrarVisita.vue